import { render, staticRenderFns } from "./FileDownloader.vue?vue&type=template&id=60d3b7f2"
import script from "./FileDownloader.vue?vue&type=script&lang=js"
export * from "./FileDownloader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports